import Vue from 'vue'
import router from '../../router'
import { invalidateUsersOptionsCache } from '../../services/users-options-cache'
import { safeLocalStorageSet } from '../../services/local-storage-safe'

const state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false }

const getters = {
	isAuthenticated: state => !!state.token,
	authStatus: state => state.status,
	token: state => state.token,
}

const actions = {
	AUTH_REQUEST: ({commit, dispatch}, user) => {
		return new Promise((resolve, reject) => {
			commit('AUTH_REQUEST')
			Vue.axios({url: 'login', data: user, method: 'POST' })
			.then(resp => {

				if(resp.data.success == false) {
					resolve(resp.data)
					return;
				}
				
				commit('AUTH_SUCCESS', resp.data.data)
				dispatch('USER_REQUEST').then(() => {
					resolve(resp.data)
					return;
				}, err => {
					// Senza questo ramo la promise non si chiudeva mai e il pulsante
					// di login restava in caricamento all'infinito: meglio fallire
					// visibilmente e lasciare che l'utente ritenti.
					reject(err)
				})
			})
			.catch(err => {
				commit('AUTH_ERROR')
				localStorage.removeItem('user-token')
				reject(err)
			})
		})
	},

	AUTH_LOGOUT: ({commit, dispatch}, all = false) => {
		const url = all ? 'logout-all' : 'logout';
		return new Promise((resolve, reject) => {
			Vue.axios({url: url, method: 'POST' })
			.then(resp => {
				Vue.axios.defaults.headers = {
					'Authorization': ''
				}
				commit('AUTH_LOGOUT')
				resolve()
			})
			.catch(err => {
				commit('AUTH_LOGOUT')
				resolve()
			})
		})
	}
}

const mutations = {
	AUTH_REQUEST: (state) => {
		state.status = 'loading'
	},
	
	AUTH_SUCCESS: (state, resp) => {
		state.status = 'success'
		// Il token è piccolo ma con la quota al limite fallisce anche lui: in quel
		// caso safeLocalStorageSet libera le cache rigenerabili e ritenta, così la
		// sessione sopravvive al refresh della pagina.
		safeLocalStorageSet('user-token', resp.token)
		Vue.axios.defaults.headers = {
			'Content-Type': 'application/json',
			'Accept': 'application/json',
			'Authorization': 'Bearer ' + resp.token
		}     
		state.token = resp.token
		state.hasLoadedOnce = true
	},
	
	AUTH_ERROR: (state) => {
		state.status = 'error'
		state.hasLoadedOnce = true
	},
	
	AUTH_LOGOUT: (state) => {
		// Si cancella da localStorage solo il token di QUESTA sessione. Con due
		// tab aperte, la tab sloggata riceveva ancora eventi (Echo restava
		// connesso), le sue chiamate prendevano 401 e questo logout cancellava
		// il token appena scritto dal login fatto nell'altra tab: quella
		// continuava a lavorare in memoria e si ritrovava sloggata al primo
		// ricaricamento, tipicamente la mattina dopo.
		try {
			const salvato = localStorage.getItem('user-token')
			if (!salvato || salvato === state.token) {
				localStorage.removeItem('user-token')
			}
		} catch (e) {
			// Storage non disponibile (navigazione privata, policy): il logout
			// deve comunque completarsi in memoria.
		}
		state.token = ''
		Vue.axios.defaults.headers.Authorization = ''
		// Niente eventi in arrivo su una tab senza sessione: ogni notifica
		// scatenava chiamate con token vuoto, quindi altri 401.
		if (Vue.prototype.$echo) {
			try { Vue.prototype.$echo.disconnect() } catch (e) { /* gia' chiuso */ }
		}
		// Il logout è soft (nessun reload): svuoto le cache di sessione che
		// non devono sopravvivere al cambio di utente. Vedi task #7276.
		invalidateUsersOptionsCache()
		router.push({ name: 'login' }).catch(err => {
			if (err.name !== 'NavigationDuplicated') {
				throw err
			}
		})
	},

	// Token scritto da un'altra tab (login fatto li'): questa tab lo adotta
	// senza rifare il login, e senza toccare localStorage, che e' gia' giusto.
	AUTH_ADOPT_TOKEN: (state, token) => {
		// Se questa tab aveva gia' una sessione, il suo Echo va chiuso prima
		// che USER_REQUEST ne apra uno con il token nuovo: altrimenti restano
		// due socket e ogni notifica arriva due volte.
		if (Vue.prototype.$echo) {
			try { Vue.prototype.$echo.disconnect() } catch (e) { /* gia' chiuso */ }
		}
		state.status = 'success'
		state.token = token
		Vue.axios.defaults.headers.Authorization = 'Bearer ' + token
	}
}

export default {
	state,
	getters,
	actions,
	mutations,
}